import { AgmMap } from '@agm/core';
import { AfterViewInit, Component, EventEmitter, Input, OnDestroy, OnInit, Output, ViewChild } from '@angular/core';
import { sweetAlert } from 'src/app/utils/swal';
import { AssigTripsService } from '../../component/assigned-trips/assigntrips-service/assigntrips-service';
import { timeCalculation } from '../../utils/utils.common';
import { KpisService } from '../../component/kpis/kpis-service/kpis.service';
import { takeUntil } from 'rxjs/operators';
import { componentDestroyed } from '@w11k/ngx-componentdestroyed';
import { environment } from 'src/environments/environment';
import { CorporateService } from '../../component/corporate-user/corporate-service/corporate-service';
import * as moment from 'moment-timezone';

@Component({
  selector: 'app-trip-detail-model',
  templateUrl: './trip-detail-model.component.html',
  styleUrls: ['./trip-detail-model.component.css']
})
export class TripDetailModelComponent implements OnInit, OnDestroy {
  @Input('tripDetailModalObj') trip: any;
  @Input() source: any;
  @Input() corporatesByKey: any
  @Input() companyToken;
  @Input() timeZone:any;
  @ViewChild("AgmMap", { static: false }) agmElement: AgmMap;
  @Output() onCloseModal = new EventEmitter<string>();
  agmMap;
  bounds;
  latitude: number;
  longitude: number;
  zoom: number = 12;
  eta;
  contact;
  tripData: any;
  driverDetails;
  trackinURL;
  serviceAreas: any;
  preLevelOfServices;
  preSpaceTypes;
  preServiceAreas;

  constructor(
    private corporateService: CorporateService,
    private assignTripService: AssigTripsService,
    private kpisService: KpisService
  ) { }

  ngOnInit() {
    this.trackinURL = environment.TRACKING_URL;
    this.getConfigurations();
    this.getTrips();
    if (this.source === "statistics") {
      this.getTripDetails();
    }
  }



  getConfigurations() {
    this.assignTripService.getConfigurations().subscribe(data => {
      if (data) {
          this.preLevelOfServices = data.levelofservices.reduce((obj, item) => (obj[item._id] = item, obj), {});;
          this.preSpaceTypes = data.spacetypes.reduce((obj, item) => (obj[item._id] = item, obj), {});;
          this.preServiceAreas = data.serviceareas.reduce((obj, item) => (obj[item._id] = item, obj), {});
      }
    });
  }

  getTrips() {
    this.assignTripService
      .tripDetail(this.trip._id, this.companyToken)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(
        (data) => {
          if (data) {
            this.tripData = data;
            if (data.priorityClient) {
              this.contact = data.priorityClient.contactNumber;
            }
            this.getCorporateUserById();
          }
        });
  }

  closeModal() {
    this.onCloseModal.emit();
  }


  getETA(tripId) {
    this.assignTripService
      .getETA(tripId)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data && data.etaMessage) {
          this.eta = data.etaMessage;
        }
      });
  }

  sendSMS() {
    if (!this.contact) return;
    this.trip.contactNumber = this.contact;

    const payload = {
      ...this.trip,
      tripId: this.trip._id,
      latitude: this.trip.driver.latitude,
      longitude: this.trip.driver.longitude,
    }
    this.assignTripService
      .sendTrackingSMS(payload)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          // this.contact = '';
          if (data.success) {
            sweetAlert('Success', data.message, 'success', 'OK');
          } else {
            sweetAlert('Error', data.message, 'error', 'OK');
          }
        }
      });
  }

  getTripDetails() {
    this.kpisService.getNemtStatsById(this.trip._id)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe(data => {
        if (data) {
          this.trip = data;
        }
      })
  }

  getJobStatus(status) {
    let tripStatus = status;

    if (status === 'pending') {
      tripStatus = 'Unassigned';
    } else if (status === 'arrived') {
      tripStatus = 'On Scene';
    } else if (status === 'started') {
      tripStatus = 'Member Onboard';
    }

    return tripStatus
  }

  breakString(str) {
    if (!str) return "";
    return str.replace(/\n/g, "<br>");
  }


  getPayorTypeTitle(corporateId, payorType) {
    if (!this.corporatesByKey) return;

    let payor;
    let types = this.corporatesByKey[corporateId];
    if (types && types.length) {
      payor = types.find(t => t.value === payorType);
    }
    return payor ? payor.title : '';
  }

  getCorporateUserById() {
    this.corporateService.getCorporateUserById(this.tripData.cooperate)
      .pipe(takeUntil(componentDestroyed(this)))
      .subscribe((data) => {
        if (data) {
          this.tripData.cooperate = data.displayName
        }

      });
  }

  ngOnDestroy(): void {
  }
}
